module.exports = "<div>\n    <div class=\"loginPageMessagesContent\" style=\"text-align: center; color: white;\">\n        <div id=\"connectContent\" class=\"pageMessage\">\n            <h2 id=\"starttitle\">&nbsp;</h2>\n        </div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// /jenkins/workspace/CudaLaunch_release_production/~/html-loader!./connect/connection_view.html
// module id = 35
// module chunks = 0 3